module.exports = __webpack_public_path__ + "static/media/Icon_Information.1d8603b0.svg";